import PurchaseRequistion from './PurchaseRequisition';

export default PurchaseRequistion;
